/* eslint-disable no-console */
/* global console */
import React, { useEffect, useMemo, useState, lazy } from "react";
import PropTypes from "prop-types";
import { TopChallengesWrapper, TopCardEngagementV1 } from "./styles";
import {
  MainContainer,
  
} from "../Recognition/CompanyAnalytics/styles";
import SkeletonLoder from "../common/skeletonLoder";
import RecommendedEvents from "./RecommendedEvents";
import MonthlyBarChart from "../common/Manager/MonthlyChart/MonthlyBarChart";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import CommonTableInfiniteScroll from "../common/CommonTable/CommonTableInfiniteScroll";
import {
  GetRecommendedEventData,
  GetEventMonthAndQuarterlyPerformance,
  GetTopEventDepartmentAndLocations, 
} from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { convertDateInTimezone, fetchApi, processTopData } from "../../utils/methods";
import { ImageUrl } from "../../utils/constants";
import {
  // AboutEventIcon,
  CompanyEventsIcon, CompanyWolibaUserEventsIcon, DatePickerIconUserEvents,
  LiveEventsIcon, NewBackArrowIconEventPage, NewNextArrowIconEventPage,
  OnDemandEventsIcon, PeopleIconForRegisteredUsers,
  StarIcon,
  UserEventsIcon,
} from "../../utils/icons";
import { Heading } from "../RecogntionAdmin/styles";
// import AddInCalendar from "../AddInCalendar";
import { ReservedButton, SliderContainer, /*ViewAllText*/ } from "../MainEvents/styles";
import moment from "moment";
import LazyImage from "../common/LazyImage/LazyImage";
import parse from "react-html-parser";
import { CompanyCard, Container, Layout, WolibaCard } from "../MainEvents/CompanyLiveEvents/styles";
import Slider from "react-slick";
// import { ImageUrl } from "../../utils/constants";
import { useSelector,useDispatch } from 'react-redux'; 
import { fetchCompanyEvents } from "../../redux/actions";
import { useTranslation } from "react-i18next";
import { attendEvent, attendEventLimitUser, fetchWolibaEvents } from "../../redux/actions/eventActions";
import AddInCalendar from "../AddInCalendar/calendarPopup";
import { connect } from 'react-redux';
import { CoachCard } from "../MainEvents/SingleEventV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";




const NextArrow = ({ currentSlide, slideCount, onClick }) => {
  const isLastSlide = currentSlide === slideCount - 1;
  if (isLastSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-next"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

NextArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

// Custom Prev Arrow Component with PropTypes
const PrevArrow = ({ currentSlide, onClick }) => {
  const isFirstSlide = currentSlide === 0;
  if (isFirstSlide) return null;
  
  return (
    <div
      className={"left-arrow slick-prev"}
      onClick={onClick}
      style={{ display: 'block' }}
    />
  );
};

PrevArrow.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

const Overview = ({
  EngagementData,
  EngagementDataLoading,
  history,
  companyId,
  selectedYear,
  wolibaEvents,
  fetchWolibaLiveEvents,
  GetEventsEngagement
}) => {
  const [RecommendedEventData, setRecommendedEventData] = useState([]);
  const [RecommendedEventDataLoading, setRecommendedEventDataLoading] = useState(false);
  const [monthData, setMonthData] = useState([]);
  const [quarterData, setQuarterData] = useState([]);
  const [monthName, setMonthName] = useState("");
  const [quarterName, setQuarterName] = useState("");
  const [pageNumberReceivedMonth, setPageNumberReceivedMonth] = useState(1);
  const [pageNumberReceivedQuarter, setPageNumberReceivedQuarter] = useState(1);
  const [monthResponse, setMonthResponse] = useState([]);
  const [quarterResponse, setQuarterResponse] = useState([]);
  const [showAllMonth, setShowAllMonth] = useState(false);
  const [showAllQuarter, setShowAllQuarter] = useState(false);
  const currentYear = new Date().getFullYear();
  const [topThreeLocation, setTopThreeLocation] = useState([]);
  const [topTotalLocation, setTopTotalLocation] = useState();
  const [topThree, setTopThree] = useState([]);
  const [topTotal, setTopTotal] = useState();

  useEffect(() => {
    if (!RecommendedEventData.length && companyId) {
      GetRecommendedEvents(companyId);
    }
  }, [RecommendedEventData.length, companyId]);

  useEffect(()=>{
    fetchWolibaLiveEvents();
  },[])

  useEffect(() => {
    if (companyId && selectedYear == currentYear) {
      fetchBestPerformDetails(1, "month", 7);
      fetchBestPerformDetails(1, "quarter", 7);
    }
  }, [companyId, selectedYear, currentYear]);
  const [currentSlide, setCurrentSlide] = React.useState(1);
  const [showCalendar, setShowCalendar] = React.useState(false);
  const [eventId, setEventId] = React.useState(null);
  const [eventName, setEventName] = React.useState("");
  const [timeout, setTimeoutState] = React.useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [sliderRef, setSliderRef] = useState(null);
  const { t } = useTranslation();
  // const sliderRef = useRef(null);
  const dispatch = useDispatch();
  const companyEvents = useSelector((state) => state.events.companyEvents);

  window.console.log("eventName",eventName,timeout)


  // const handleBeforeChange = (oldIndex, newIndex) => {
  //   // Update the current slide index when the slider changes
  //   setCurrentSlide(newIndex + 1);
  // };



  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex + 1);
  };


  const sortDataByDate = (data) => {
    window.console.log("hi")
    return data.sort(
      (a, b) => new Date(a.start_date) - new Date(b.start_date)
    );
  };
  
  const companyLiveEvents = useMemo(() => {
    window.console.log("hi")
    return companyEvents && companyEvents.length
      ? sortDataByDate([...companyEvents]) 
      : [];
  }, [companyEvents]); 


  window.console.log("companyLiveEvents", companyLiveEvents);


  const companyLive = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    adaptiveHeight: true,
    nextArrow: <NextArrow currentSlide={currentSlide} slideCount={companyLiveEvents?.length} />,
    prevArrow: <PrevArrow currentSlide={currentSlide} />,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={companyLiveEvents?.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          infinite: false,
          speed: 500,
          draggable: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          nextArrow: <NextArrow currentSlide={currentSlide} slideCount={companyLiveEvents.length} />,
          prevArrow: <PrevArrow currentSlide={currentSlide} />,
        },
      },
    ],
  };




  // let companyLive = {
  //   dots: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   draggable: true,
  //   adaptiveHeight: true,
  //   nextArrow: <div className={"left-arrow slick-next"} />,
  //   prevArrow: <div className={"left-arrow slick-prev"} />,
  //   beforeChange: handleBeforeChange,
  //   responsive: [
  //     {
  //       breakpoint: 1252,
  //       settings: {
  //         dots: true,
  //         infinite: true,
  //         speed: 500,
  //         draggable: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows: true,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         dots: true,
  //         infinite: true,
  //         speed: 500,
  //         draggable: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows: true,
  //       },
  //     },
  //   ],
  // };

  const convertMonthFromDate = (dateString) => {
    let temp = dateString.split(" ");
    temp[0] = t(temp[0]);
    temp = temp.join(" ");
    return temp;
  };

  // Fetch events on component mount
  useEffect(() => {
    dispatch(fetchCompanyEvents());
  }, []);


  const calendarConfirmPopup = () => {
    setTimeoutState(true);
  };

  const hideCalendar = (id) => {
    setShowCalendar((prev) => !prev);
    setEventId(id);
  
    dispatch(attendEvent(id, 0, 1));
    calendarConfirmPopup();
  };
  

  const showCalendarData = (id) => {
    setShowCalendar((prev) => !prev);
    setEventId(id);
  };

  
  
  const showCalendarHandler = (id, title, event) => {
    event.stopPropagation();
    setShowCalendar(true);
    setEventId(id);
    setEventName(title);
  };


  const showHideCalendarLogic = () => {
    setShowCalendar((prev) => !prev);
  };


  const showCalendarAndReserve = async(id, isAttending, title, event) => {
    event.stopPropagation();
  
    if (isAttending !== 1) {
      setShowCalendar((prev) => !prev);
    }
  
    setEventId(id);
    setEventName(title);
    setIsButtonDisabled(true);
  
    // Call the action passed via props (or from Redux dispatch)
    // dispatch(attendEventLimitUser(id, isAttending, showHideCalendarLogic));
   

    try {
      await dispatch(attendEventLimitUser(id, isAttending, showHideCalendarLogic));
      fetchBestPerformDetails(1, "month", 7);
      fetchBestPerformDetails(1, "quarter", 7);
      fetchAllAnalyticsDetails();
      GetEventsEngagement(companyId,selectedYear)
    } finally {
      setIsButtonDisabled(false);
    }
    
  
    window.setTimeout(() => {
      setIsButtonDisabled(false);
    }, 2000);
  };
  

 


  


  useEffect(() => {
    fetchAllAnalyticsDetails();
  }, [selectedYear]);

  const handleShowMoreMonth = (month) => {
    setShowAllMonth((prev) => ({ ...prev, [month]: !prev[month] }));
  };

  const handleShowMoreQuarter = (quarter) => {
    setShowAllQuarter((prev) => ({ ...prev, [quarter]: !prev[quarter] }));
  };

  const setPageNumberPaginationReceivedMonth = (value) => {
    setPageNumberReceivedMonth(value);
    fetchBestPerformDetails(value, "month", 7);
  };

  const setPageNumberPaginationReceivedQuarter = (value) => {
    setPageNumberReceivedQuarter(value);
    fetchBestPerformDetails(value, "quarter", 7);
  };



  // const redirection = () => {
  //   history.push("/events/live");
  // };

  

  const GetRecommendedEvents = async (companyId) => {
    setRecommendedEventDataLoading(true);
    const apiUrl = `${GetRecommendedEventData}${companyId ? `/${companyId}` : ""}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setRecommendedEventData(res?.data);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setRecommendedEventDataLoading(false);
    }
  };

  const fetchBestPerformDetails = async (page, type, limit) => {

  
    let company_id = companyId;
    
  
    let apiUrl = `${GetEventMonthAndQuarterlyPerformance}/${company_id}/${type}/${selectedYear}/${page}/${limit}`;
      
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
  
        if (type === "month") {
          setMonthResponse(res.data.current_month)
          setMonthName(res.data.current_month.month_name);
          const formattedData = res.data.current_month.data.map((member) => ({
            name: member?.user_name || "",  // Use an empty string instead of "NA"
            image: member?.profile_image || "profile-Image/default.png",
            department: member?.department || "",
            location: member?.location || "",
            total_posts: member?.participation_count || 0,
          }));
  
          if (page === 1) {
            setMonthData([...formattedData]);
          } else {
            setMonthData([...monthData, ...formattedData]);
          }
  
        } else {
          setQuarterResponse(res.data.current_quarter)
          setQuarterName(res.data.current_quarter.quarter_name);
          const formattedData = res.data.current_quarter.data.map((member) => ({
            name: member?.user_name || "",  // Use an empty string instead of "NA"
            image: member?.profile_image || "profile-Image/default.png",
            department: member?.department || "",
            location: member?.location || "",
            total_posts: member?.participation_count || 0,
          }));
  
          if (page === 1) {
            setQuarterData([...formattedData]);
          } else {
            setQuarterData([...quarterData, ...formattedData]);
          }
        }
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  
  }

  const fetchAllAnalyticsDetails = async () => {
    const apiUrl = `${GetTopEventDepartmentAndLocations}/${companyId}/year/${selectedYear}`;
    const backgroundColorsMap = {
      department: ["#B1AA56", "#92A4DA", "#DA9B6C"],
      location: ["#B1AA56", "#C96BAE", "#75B084"],
    };
    
    const widthSize = [204, 160, 96];
  
    try {
      const res = await fetchApi(apiUrl, "GET");
  
      if (res.status === "success") {
        const {
          top_three_departments = [],
          total_top_departments = 0,
          top_three_locations = [],
          total_top_locations = 0,
        } = res.data || {};
  
        // Process and set departments
        setTopTotal(total_top_departments);
        const processedDepartments = processTopData(
          top_three_departments,
          backgroundColorsMap.department,
          widthSize,
          "total_participation"
        );
        setTopThree(processedDepartments);
  
        // Process and set locations
        setTopTotalLocation(total_top_locations);
        const processedLocations = processTopData(
          top_three_locations,
          backgroundColorsMap.location,
          widthSize,
          "total_participation"
        );
        setTopThreeLocation(processedLocations);
  
      } else {
        toast.error(res?.error || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
    }
  };


  const topLocation = () => {
    if (!topThreeLocation?.length) return null;
  
    return (
      <TopDataGraph
        data={topThreeLocation}
        heading="Top Performing Locations"
        total={topTotalLocation}
        totalSubText="Total Events"
      />
    );
    
  };

  const topDepartment = () => {
    if (!topThree?.length) return null;
  
    return (
      <TopDataGraph
        data={topThree}
        heading="Top Performing Departments"
        total={topTotal}
        totalSubText="Total Events"
      />
    );
  };

  const showEngagementEmployeeDetail = () => {
    const EngagementEmployeeData = [
      {
        title: "Events Engagement",
        img: UserEventsIcon("white"),
        text: "per user",
        imageBackground: "#BE7D9C",
        total: EngagementData?.engagement_total,
        average: `${EngagementData?.engagement_average} event${EngagementData?.engagement_average > 1 ? "s" : ""}`,
      },
      {
        title: "Live Events Attended",
        img: LiveEventsIcon(),
        text: "per user",
        imageBackground: "#75B084",
        total: EngagementData?.live_events_total,
        average: `${EngagementData?.live_events_average} live event${EngagementData?.live_events_average > 1 ? "s" : ""}`,
      },
      {
        title: "On-Demand Lunch and Learns",
        // titleNew: "Lunch and Learns",
        value: "3",
        img:OnDemandEventsIcon(),
        text: "per user",
        imageBackground: "#DA92C8",
        total: EngagementData?.on_demand_events_total,
        // average: `${EngagementData?.on_demand_events_average} lunch and learn${EngagementData?.on_demand_events_average > 1 ? "s" : ""}`,
        average: `${EngagementData?.on_demand_events_average} lunch and learns`,
      },
      {
        title: "Total Company Events Created",
        img: CompanyEventsIcon(),
        text: "per year",
        imageBackground: "#92A4DA",
        total: EngagementData?.company_events_total,
        average: `${EngagementData?.company_events_average} event${EngagementData?.company_events_average > 1 ? "s" : ""}`,
      },
    ];

    return EngagementDataLoading ? 
      EngagementEmployeeData.map((_, index) => (
        <SkeletonLoder width={"288px"} height={"180px"} key={index} />
      )) : 
      EngagementEmployeeData.map((details, index) => (
        <TopCardEngagementV1
          key={index}
          background={details.imageBackground}
          style={{ padding: "12px 8px" }}
        >
          <div className="first-child">
            <div className="image">
              <div className="icon">{details.img}</div>
            </div>
            <div className="title">{details.title}</div>
            <span className="value">{details?.total}</span>
          </div>
          <div className="last-child">
            <span className="participateText">
              {index === 3 ? "Aim for" : "Average"}
            </span>
            <span className="participateText">{details.average}</span>
            <span className="participateText">{details.text}</span>
          </div>
        </TopCardEngagementV1>
      ));
  };

  const convertMonthlyBreakdownToArray = () => {
    const monthOrder = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return monthOrder.map((month) => ({
      month,
      count: EngagementData?.monthly_breakdown?.[month] || 0,
    }));
  };

  const eventBestPerformer = () => (
    <>
      {monthData?.length > 0 && (
        <div className="top-performing" style={{ display: "block" }}>
          <CommonTableInfiniteScroll
            title={`${monthName} | Monthly`}
            headers={["Employees", "Total Events"]}
            data={monthData}
            showAll={showAllMonth}
            handleShowMore={handleShowMoreMonth}
            imageBaseUrl={true}
            res={monthResponse}
            pageNumberReceived={pageNumberReceivedMonth}
            setPageNumberPaginationReceived={setPageNumberPaginationReceivedMonth}
          />
        </div>
      )}
      {quarterData?.length > 0 && (
        <div className="low-performing" style={{ display: "block" }}>
          <CommonTableInfiniteScroll
            title={`${quarterName} | Quarterly`}
            headers={["Employees", "Total Events"]}
            data={quarterData}
            showAll={showAllQuarter}
            handleShowMore={handleShowMoreQuarter}
            imageBaseUrl={true}
            res={quarterResponse}
            pageNumberReceived={pageNumberReceivedQuarter}
            setPageNumberPaginationReceived={setPageNumberPaginationReceivedQuarter}
          />
        </div>
      )}
    </>
  );

  const chartData = convertMonthlyBreakdownToArray();

  const WolibaLiveEvents = (wolibaLiveEvents)=>(
    wolibaLiveEvents && wolibaLiveEvents.length === 0 ? null : (
      <Layout width margin="15px 0px 0px 0px" padding="0 0 0px 0">
        <div className="headingMain">
          <div style={{ gap: "12px" }} className="heading">
            <CompanyWolibaUserEventsIcon />
            {t("Woliba Live Events")}
          </div>
          {/* {wolibaLiveEvents && wolibaLiveEvents.length > 2 ? (
            <ViewAllText
              style={{ gap: "12px" }}
              onClick={() => redirection()}
            >
              {`${t("View All")}`} {NewNextArrowIconEventPage()}
            </ViewAllText>
          ) : null} */}
        </div>
        {wolibaLiveEvents && wolibaLiveEvents.length > 0 ? (
          <div className="cardWrapper">
            {wolibaLiveEvents &&
              wolibaLiveEvents.slice(0, 3).map((data, index) => (
                <WolibaCard
                  key={index}
                  width="calc((100% - 50px) / 3)"
                  margin={
                    (index + 1) % 3 === 0
                      ? "0 0 0px 0"
                      : "0 25px 0px 0"
                  }
                  maxHeight={'340px'}
                >
                  {data?.coach_details ? (
                    <CoachCard
                      onClick={() =>
                        history.push(`/company/events/${data.id}`)
                      }
                    >
                      <div className="cardWrapper">
                        <div className="imagecard">
                          <img
                            src={`${ImageUrl}/${data?.coach_details?.image}`}
                          />
                        </div>
                        <div className="coach-details">
                          <div className="title">
                            {data?.coach_details?.name}
                          </div>
                          <div className="info">
                            {data?.coach_details?.education}
                          </div>
                        </div>
                      </div>
                    </CoachCard>
                  ) : (
                    <LazyImage
                      div={"imageCard"}
                      onClick={() =>
                        history.push(`/company/events/${data.id}`)
                      }
                      src={`${ImageUrl}/${data.image}`}
                      alt="category"
                    />
                  )}
                  <div className="bg-opacity"> </div>
                  <div className="detailsCard">
                    <div className="titleCard">
                      <div className="title">{data.title}</div>
                      {/* <div
                        className="icon"
                        onClick={(event) =>
                          this.toggleModal(data.id, event)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <AboutEventIcon/>
                      </div> */}
                    </div>
                    <div className="time">
                      {moment(
                        convertDateInTimezone(data && data.start_date)
                          ._d
                      ).format("ddd MMM DD, hh:mm a")}{" "}
                      ({data.abbreviation}) |{" "}
                      {data.event_location
                        ? t("Onsite")
                        : t("Virtual")}
                    </div>
                  </div>

                  {/* {data.is_attending === 1 && !data.event_location &&
                       moment(convertDateInTimezone(data.start_date)._d) < new Date() &&
                       data.event_status !== "over" ? (
                        <a
                          href={data.event_encrypted_link || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ width: "100%", textDecoration: "none" }}
                        >
                          <ReservedButton active={true} width="100%">
                            {t("Join Event")}
                          </ReservedButton>
                        </a>
                      ) : (
                        data.is_lunch_and_learn_event === 1 && data.event_link ? null : (
                          <ReservedButton
                            active={!data.is_attending}
                            width="100%"
                            onClick={
                              isButtonDisabled
                                ? null
                                : (event) =>
                                  this.handleWolibaLive(
                                    data.id,
                                    data.is_attending,
                                    event
                                  )
                            }
                          >
                            {!data.is_attending
                              ? t("Reserve Spot")
                              : t("Cancel Reservation")}
                          </ReservedButton>
                        )
                      )}

                  </div>
                  {eventCalendarId === data.id &&
                    showAboutEventModal && (
                    <AboutTheEventModal
                      showModal={showAboutEventModal}
                      onHide={this.toggleModalV2}
                      title={(data && data.title) || ""}
                      body={(data && data.body) || ""}
                    />
                  )}
                  {showCalendar && eventId === data.id && (
                    <AddInCalendar
                      show={showCalendar}
                      closeModal={this.showCalendarData}
                      hideCalendar={this.hideCalendar}
                      event={data}
                      width={"100%"}
                      margin={"0%"}
                    />
                  )} */}
                </WolibaCard>
              ))}
          </div>
        ) : (
          <h1 style={{ paddingLeft: "25px" }}>
            {t("No Woliba Live Events")}
          </h1>
        )}
      </Layout>
    )
  )

  const CompanyLiveEvents = ()=>(
    companyLiveEvents && companyLiveEvents?.length === 0 ? null : (
      <Layout style={{background:'#fff', border:'0.75px solid #DCDCDC'}} margin={"20px 0 20px 0"} padding={"20px 20px 30px 20px"} background={'#fff'} >
        <div className="headingMain">
          <div style={{ gap: "12px" }} className="heading">
            <CompanyWolibaUserEventsIcon />
            {("Company Events")}
          </div>
          {companyLiveEvents?.length > 1 ? (
            <div className="arrows">
              <div
                className="iconBackground"
                // onClick={() => sliderRef.current?.slickPrev()}
                onClick={() => sliderRef?.slickPrev()}
                style={{ 
                  opacity: currentSlide === 1 ? 0 : 1,
                  cursor: currentSlide === 1 ? 'not-allowed' : 'pointer'
                }}
              >
                {NewBackArrowIconEventPage()}
              </div>
              <div className="text">
                {currentSlide}/
                {companyLiveEvents?.length}
              </div>
              <div
                className="iconBackground"
                // onClick={() => this.slider.slickNext()}
                onClick={() => currentSlide < companyLiveEvents?.length && sliderRef?.slickNext()}
                style={{ 
                  opacity: currentSlide === companyLiveEvents?.length ? 0 : 1,
                  cursor: currentSlide === companyLiveEvents?.length ? 'not-allowed' : 'pointer'
                }}
                // onClick={() => sliderRef.current?.slickNext()}
              >
                {NewNextArrowIconEventPage()}
              </div>
            </div>
          ) : null}
        </div>
        <Container>
          {companyLiveEvents?.length > 0 && (
            <SliderContainer
              display="flex"
              content="center"
              shadow="0px 8px 25px 0px #0D427040"
             
            >
             
              <Slider {...companyLive}
                ref={(slider) => setSliderRef(slider)}
              //  ref={sliderRef}  
              >
                {companyLiveEvents?.length > 0 &&
                        companyLiveEvents.map((data, index) => (
                          <div className="card featCard" key={index} style={{paddingRight:'0', marginRight:'-30px !important'}}>
                            <CompanyCard
                              // buttonJustifyContent="center"
                              className="featChallanges" 
                              detailsCardPadding="0 0 10px 20px"
                              width="1248px"
                              onClick={() => history.push(`/company/events/${data.id}`)}
                            >
                              <LazyImage
                                div={"imageCard featImg"} style={{borderRadius:'8px 0  0 8px'}}
                                src={`${ImageUrl}/${data.image}`}
                                alt="category"
                              />
                              <div className="detailsCard" style={{border:'0.75px solid #DCDCDC',padding:'0 20px 20px 20px',borderRadius:'0 8px 8px 0',borderLeft:'0'}}>
                                <div className="title">{data.title}</div>
                                <div className="details" style={{paddingTop:'20px'}}>
                                  {parse(data.body)}
                                </div>
                                <div className="date">
                                  <div className="iconV1">
                                    <DatePickerIconUserEvents />
                                  </div>
                                  <div className="detail">
                                    {convertMonthFromDate(
                                      moment(
                                        convertDateInTimezone(
                                          data?.start_date
                                        )._d
                                      ).format("MMM DD, YYYY | hh:mm A")
                                    )}
                                    {!data.is_all_day_event &&
                                      ` IST - ${moment(
                                        convertDateInTimezone(
                                          data?.end_date
                                        )._d
                                      ).format(
                                        "MMM DD, YYYY | hh:mm A"
                                      )} IST`}
                                  </div>
                                </div>
                                {data?.attendees_list?.length > 0 ? (
                                  <div className="date">
                                    <div className="iconV1" >
                                      <PeopleIconForRegisteredUsers />
                                    </div>
                                    <div className="detail">
                                      {data?.attendees_list?.length}{" "}
                                      {(" Registered ")}
                                      {data?.attendees_list?.length > 1
                                        ? ("Users")
                                        : ("User")}
                                    </div>
                                  </div>
                                ) : null}

                                {data?.event_type === "theme"  ? <CommonButtonBorder onClick={()=> history.push(`/events/${data.id}`)}  height={'40px'}width={'436px'} margin={'auto 0 0 0'}>View Event </CommonButtonBorder>  : null }

                                
                                {(data.is_lunch_and_learn_event === 1 &&
                                data.event_link) ||  data.event_type === "theme"  ? null : (
                                 
                                    <div className="buttonContainer"  style={{marginTop:"auto"}}> 
                                      {data.event_status !== "over" &&
                                      data.is_attending === 1 &&
                                      !data.event_location &&
                                      moment(convertDateInTimezone(data.start_date)._d) < new Date()
                                        ? (
                                          <a
                                            href={data.event_encrypted_link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ width: "436px", textDecoration: "none" }}
                                          >
                                            <ReservedButton active={true} width="100%">
                                              {("Join Event")}
                                            </ReservedButton>
                                          </a>
                                        ) : (
                                          <>
                                            {data.is_attending === 1 && (
                                              <ReservedButton
                                                active={1}
                                                // onClick={(event) =>
                                                //   this.showCalendar(data.id, data.title, event)
                                                // }
                                                onClick={(event) => showCalendarHandler(data.id, data.title, event)}
                                              >
                                                Add to Calendar
                                              </ReservedButton>
                                            )}
                                    
                                            <ReservedButton
                                              width={!data.is_attending ? "436px" : undefined}
                                              active={!data.is_attending}
                                            
                                              onClick={
                                                isButtonDisabled
                                                  ? null
                                                  : (event) =>
                                                    showCalendarAndReserve(
                                                      data.id,
                                                      data.is_attending,
                                                      data.title,
                                                      event
                                                    )}
                                            >
                                              {!data.is_attending
                                                ? ("Reserve Spot")
                                                : ("Cancel Reservation")}
                                            </ReservedButton>
                                          </>
                                        )}
                                    </div>
                                    
                                  )}
                              </div>
                            </CompanyCard>
                            {showCalendar && eventId === data.id && (
                              <AddInCalendar
                                show={showCalendar}
                                closeModal={showCalendarData}
                                hideCalendar={hideCalendar}
                                event={data}
                                width={"100%"}
                                margin={"0%"}
                              />
                            )}
                          </div>
                        ))}
              </Slider>
            </SliderContainer>
          )}
        </Container>
      </Layout>
    ))

  return (
    <>
      <MainContainer margin>
        <TopChallengesWrapper>
          {showEngagementEmployeeDetail()}
        </TopChallengesWrapper>

        {WolibaLiveEvents(wolibaEvents)}

        {selectedYear == currentYear && monthData?.length > 0 && (
          <>
            <Heading isMargin="15px 0px">
              <div className="icon">
                {StarIcon("#184A61")}
              </div>
            Best Performers
            </Heading>
            <div className="main-top-low-card" style={{ marginTop: "20px" }}>
              {eventBestPerformer()}
            </div>
          </>
        )}

        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          <div className='top-performing'>{topDepartment()}</div>
          <div className='top-performing'>{topLocation()}</div>
        </div>

        {CompanyLiveEvents()}


        {RecommendedEventData?.length > 0 && (
          <RecommendedEvents
            RecommendedEventData={RecommendedEventData}
            margin="15px 0px 20px 0px"
            isActivity="1"
            history={history}
            RecommendedEventDataLoading={RecommendedEventDataLoading}
            heading={
              <Heading style={{ margin: "0px" }}>
                <div style={{ marginRight: "16px", display: "flex" }}>
                  {StarIcon("#184A61")}
                </div>
                <div>Featured Event of the Month</div>
              </Heading>
            }
          />
        )}



      </MainContainer>
      <div style={{ marginTop: "20px" }} id="monthly-brakedown">
        <MonthlyBarChart
          heading="Monthly Breakdown"
          total={EngagementData?.total_events_participation || 0}
          totalText="Event Participation"
          totalPercentage={EngagementData?.monthly_growth || 0}
          dataGraph={chartData}
          isDynamicMonth={true}
          dynamicMonthsName={chartData.map((item) => item.month)}
          widthType="half"
          barColor="#CE98B3"
          barColorActive="#5B73A3"
          showYAxis={false}
          id="monthly-bar"
        />
      </div>
    </>
  );
};

Overview.propTypes = {
  EngagementData: PropTypes.object.isRequired,
  companyId: PropTypes.number,
  EngagementDataLoading: PropTypes.bool,
  history: PropTypes.object.isRequired,
  topThree: PropTypes.array,
  topTotal: PropTypes.number,
  topThreeLocation: PropTypes.array,
  topTotalLocation: PropTypes.number,
  selectedYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  companyEvents: PropTypes.array,
  wolibaEvents:PropTypes.array,
  fetchWolibaLiveEvents:PropTypes.func,
  GetEventsEngagement:PropTypes.func,
  
};

const mapStateToProps = (state) => ({
  wolibaEvents: state.events.wolibaEvents,
})

const mapDispatchToProps = (dispatch) => ({
  fetchWolibaLiveEvents: () => dispatch(fetchWolibaEvents()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Overview);


